import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
    ActivityDueDate,
    ProcessOutcome,
    SystemEntity,
    WorkItem,
} from '@wdx/clmi/clmi-swagger-gen';
import { ActivityIdDuedateApiService } from '@wdx/clmi/clmi-swagger-gen/api-services';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class WorkItemsService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);
    private activityIdDuedateApiService = inject(ActivityIdDuedateApiService);

    getWorkItemsForSystemEntity(
        systemEntity: SystemEntity,
        systemEntityId: string,
    ): Observable<WorkItem[]> {
        return this.http.get<WorkItem[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/${systemEntity.toLowerCase()}/${systemEntityId}/workitem`,
        );
    }

    getWorkItem(workItemId: string): Observable<WorkItem> {
        return this.http.get<WorkItem>(
            `${this.config.getConfiguration().API_BASE}/workitem/${workItemId}`,
        );
    }

    getWorkItemOutcomes(workItemId: string): Observable<ProcessOutcome[]> {
        return this.http.get<ProcessOutcome[]>(
            `${this.config.getConfiguration().API_BASE}/workitem/${workItemId}/outcomes`,
        );
    }

    setWorkItemDueDate(workItemId: string, date: Date): Observable<WorkItem> {
        return this.activityIdDuedateApiService.patch(
            workItemId,
            new ActivityDueDate({
                dueDate: date.toISOString(),
            }),
        );
    }
}
